<template>
  <dtunes-modal :dialog="dialog" @openModal = "dialog = true" @closeModal = "dialog = false">
    <template v-slot:button> Create giftcard</template>
    <template v-slot:content>
      <v-card class="pad-10">
        <v-card-title class="d-flex justify-center">
          <p class="text-center">CREATE GIFTCARD</p>
        </v-card-title>
        <v-card-text>
          <v-text-field color="auto" label="Name" v-model="name" outlined></v-text-field>

          <!-- <div v-if=" categoryToggle == 0">
            <label @click=" categoryToggle = 1" style="cursor:pointer" for=""><span class="orange--text pointer">Click here to create a new category</span></label>
            <v-select :items="categories" color="auto" item-text="name" return-object v-model="category" @change="Currency" label="Select Category" outlined>
              <template v-slot:selection="{ item }">
                  <img class="rounded mr-3" width="30" height="30" contain :src="item.countryObject.flag" />{{ item.name }}
              </template>
              <template v-slot:item="{ item }">
                  <img width="30" height="30" class="rounded mr-3" :src="item.countryObject.flag">{{ item.name }}
              </template>
            </v-select>
          </div> -->
          
          <div v-if=" categoryToggle == 1" style="background:#f7f7f7; padding:10px 10px 5px 10px">
            <!-- <label for=""><span><b>Category Field</b></span></label> -->
            <v-select :items="countries" item-text="name" return-object v-model="country" @change="Currency" label="Country" outlined>
              <template @change="Currency(item)" v-slot:selection="{ item }">
                  <img class="rounded mr-3" width="30" height="30" contain :src="item.flag" />{{ item.name }}
              </template>
              <template @change="Currency(item)" v-slot:item="{ item }">
                  <img width="30" height="30" class="rounded mr-3" :src="item.flag">{{ item.name }}
              </template>
            </v-select>
            <v-select :items="types" v-model="type" label="Type" outlined></v-select>
            <v-row>
              <v-col cols="6">
                <v-text-field :prepend-inner-icon="symbol" color="auto" v-model="cardMin" label="Card Minimun" type="number" outlined></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field :prepend-inner-icon="symbol" color="auto" v-model="cardMax" label="Card Maximum" type="number" outlined></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6">
                <v-text-field :prepend-inner-icon="symbol" color="auto" v-model="minimum" label="Minimun" type="number" outlined>
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field :prepend-inner-icon="symbol" color="auto" v-model="maximum" label="Maximum" type="number" outlined>
                </v-text-field>
              </v-col>
            </v-row>
            <!-- <span class="orange--text" style="cursor:pointer" @click="categoryToggle = 0">Select from existing list </span> -->
          </div>

          <br v-if=" categoryToggle == 1">
          <v-text-field color="auto"  type="number" v-model="rate" label="Enter Rate" outlined></v-text-field>
          <br />
          <default-button :loading = "loading" @click="createGiftcard()">Create giftcard</default-button>
        </v-card-text>
      </v-card>
    </template>
  </dtunes-modal>
</template>

<script>

// ========== IMPORT COMPONENTS =============
import DtunesModal from "@/components/dtunes-modal.vue";
import DefaultButton from "@/components/Buttons/default-button.vue";

// ============ IMPORT SERVICES ===============
import { StoresService } from "@/services";
import { CategoryTypeEnum } from "@/enums"

export default {
  data: () => ({
    name : '',
    rate : '',
    tmStamp: '',
    loading : false,
    dialog:false,
    //CATEGORY
    categories : [],
    category:'',
    categoryToggle : 1,
    countries:[],
    types:[CategoryTypeEnum.ECODE, CategoryTypeEnum.PHYSICAL],
    country:'',
    symbol:'',
    minimum:'',
    maximum: '',
    cardMin: '',
    cardMax: '',
    type:''
  }),
  components: {
    DtunesModal,
    DefaultButton,
  },
  mounted(){
    this.loadGiftcards();
    this.loadCountries();
  },
  methods:{

    // ============== METHOD TO LOAD STORE GIFTCARDS ============
     async loadGiftcards(){
      try {
        const data = await StoresService.loadGiftcards({ store : this.$route.params.id});
        this.categories = data;
      } catch (error) {
        console.log(error);
      }
    },

     // =========== METHOD TO LOAD COUNTRY =============
    async loadCountries(){
      try{
        const data = await StoresService.loadCountries();
        this.countries = data;
      }
      catch(error){
        console.log(error);
      }
    },

    // =========== METHOD TO GET SELECTED COUNTRY CURRENCY SYMBOL =============
    Currency(symbol){
      this.symbol = symbol.currencySymbol;
    },

    // ============= METHOD TO CREATE GIFTCARD ======
    async createGiftcard(){
      try {
        this.loading = true
        // if( this.categoryToggle == 1){
        //   await this.createCategory()
        // }
        let payload = {
          store : this.$route.params.id,
          // category: this.category,
          // name: this.name,
          rate: Number(this.rate),
          name: this.name,
          country: this.country['id'],
          type: this.type,
          min: Number(this.minimum),
          max: Number(this.maximum),
          cardMin: Number(this.cardMin),
          cardMax: Number(this.cardMax)
        };
        const data = await StoresService.createGiftcard(payload);
        this.loading = false
        this.$store.dispatch('toast', {
          message: ` ${this.name} Giftcard created sucessfully`,
          variant: 'success'
        });
        this.dialog = false;
        this.$emit('reload');
        console.log(data);
      } catch (error) {
          this.loading = false
          console.log(error);
      }
    }
  }
};
</script>